<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :selectShow="false"
      :show="false"
      @giveAddDialog="synchronous()"
      giveCoupons="/onlineapplicationcardresources/synchronous"
      giveName="资源同步"
      :shows="true"
    >
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="merCardName"
        label="信用卡名称"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="labelTitle"
        label="标签"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cardAmount"
        label="佣金(元)"
        min-width="220"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="merCardId"
        label="资源ID"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="auditType"
        label="结算类型"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{
            scope.row.auditType == "2"
              ? "普通结算"
              : scope.row.auditType == "3"
              ? "卡类型结算"
              : "--"
          }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="hasPerm('/onlineapplicationcardresources/look')"
        label="操作"
        min-width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="showDialog(scope.row)"
            >资源明细
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <show-info-dialog
      title="资源明细"
      :show="true"
      ref="showInfoDialog"
      class="showInfoDialog"
      dialogWidth="1000px"
    >
      <div class="info">
        <div>信用卡名称：{{ answershow.merCardName }}</div>
        <div>资源ID：{{ answershow.merCardId }}</div>
        <div>标签：{{ answershow.labelTitle }}</div>
        <div>
          结算类型：{{
            answershow.auditType == "2"
              ? "普通结算"
              : answershow.auditType == "3"
              ? "卡类型结算"
              : "--"
          }}
        </div>
        <div>初审M金额：{{ answershow.comAmount0 }}</div>
        <div>初审H金额：{{ answershow.mayComAmount0 }}</div>
        <div>核卡M金额：{{ answershow.comAmount1 }}</div>
        <div>核卡H金额：{{ answershow.mayComAmount1 }}</div>
        <div>激活M金额：{{ answershow.comAmount2 }}</div>
        <div>激活H金额：{{ answershow.mayComAmount2 }}</div>
        <div>首刷M金额：{{ answershow.comAmount3 }}</div>
        <div>首刷H金额：{{ answershow.mayComAmount3 }}</div>
        <div>补贴M金额：{{ answershow.comAmount4 }}</div>
        <div>补贴H金额：{{ answershow.mayComAmount4 }}</div>
        <div>进件M金额：{{ answershow.incomingAmount }}</div>
        <div>进件H金额：{{ answershow.mayIncomingAmount }}</div>
      </div>
      <div class="url">
        进件查询地址：{{ answershow.creditCardProgressedUrl }}
      </div>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

import OnlineService from "service/OnlineService";

import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "onlineapplicationcardresources",
  components: {
    CommonTopForm,
    CommonTable,
    ShowInfoDialog,
  },
  data() {
    return {
      formModel: {},
      tableData: [],
      submitService: OnlineService.onlineapplicationcardresourcesList,
      page: {},
      isPage: false,
      answershow: {},
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      this.params = {
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {};
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    synchronous(item) {
      this.showConfirm("是否执行资源同步操作？")
        .then(() => {
          this.showLoading("获取中...");
          this.dosynchronous();
        })
        .catch(() => {});
    },
    dosynchronous() {
      this.doLoad(
        OnlineService.onlineapplicationcardresourcessync,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    showDialog(row) {
      this.answershow = row;
      this.$refs.showInfoDialog.open();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
  },
};
</script>

<style scoped>
.info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.url {
  display: flex;
  flex-wrap: wrap;
  height: 40px;
  align-items: center;
  padding-left: 5px;
}
.info div {
  width: 240px;
  height: 40px;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OnlineApplicationCard/OnlineApplicationCardResources.vue